/**
 * Card product list: hover panel + quick add.
 * - Desktop: full-card PDP link; hover shows Subscribe / One-time; click quick-adds via hidden product-form.
 * - Mobile (≤989px): one "Add to cart" opens bottom sheet with Subscribe / One-time; same quick-add (modal moves to body — resolve card by data-*).
 */
(function () {
  const LIST_SELECTOR = '.product-grid-list';
  const BOX_GRID_SELECTOR = '.box-product-grid';
  const CARD_WRAPPER_SELECTOR = '.card-wrapper';
  const TRIGGER_SELECTORS = '.subscribe-btn, .one-time-btn';
  const MOBILE_ADD_TRIGGER = '.card-product-list__mobile-add-trigger';
  const MODAL_PREFIX = 'CardQuickAddModal-';
  const ROAST_TYPE_LABEL = 'Roast Type';
  const SUBSCRIPTION_VALUE = 'Subscription';
  const MOBILE_BREAKPOINT = 989;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  /**
   * When the modal is moved to body, use data-product-id + data-section-id to find the card (any grid).
   * @param {Element} el - event target
   */
  function resolveCardWrapper(el) {
    var w = el.closest(CARD_WRAPPER_SELECTOR);
    if (w) return w;
    var modal = el.closest('modal-dialog[id^="' + MODAL_PREFIX + '"]');
    if (modal) {
      var pid = modal.getAttribute('data-product-id');
      var sid = modal.getAttribute('data-section-id');
      if (pid && sid) {
        return document.querySelector(
          '.product-grid-list .card-wrapper[data-product-id="' + pid + '"][data-section-id="' + sid + '"]'
        );
      }
    }
    return null;
  }

  /**
   * Set an option wrapper (select or fieldset with radios) to a value and dispatch change.
   * @param {Element} optionWrapper - .product-form__input element
   * @param {string} value - option value to set
   * @returns {boolean} - true if value was set
   */
  function setOptionAndDispatchChange(optionWrapper, value) {
    if (!optionWrapper || value == null || value === '') return false;
    const select = optionWrapper.querySelector('select');
    if (select) {
      if (select.value === value) return false;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const radio = optionWrapper.querySelector('input[type="radio"][value="' + value.replace(/"/g, '\\"') + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  /**
   * Find the option wrapper whose label/legend text contains the given name (e.g. "Roast Type").
   */
  function findOptionWrapperByLabel(variantSelects, labelText) {
    const wrappers = variantSelects.querySelectorAll('.product-form__input');
    for (let i = 0; i < wrappers.length; i++) {
      const label = wrappers[i].querySelector('.form__label');
      if (label && label.textContent.indexOf(labelText) !== -1) {
        return wrappers[i];
      }
    }
    return null;
  }

  /**
   * Get or create the selling_plan hidden input in the form.
   */
  function getOrCreateSellingPlanInput(form) {
    let input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.className = 'selling-plan-input';
      form.appendChild(input);
    }
    return input;
  }

  /**
   * Find an option wrapper that supports a specific value (select option or radio value).
   * Useful fallback when label matching isn't reliable across products.
   */
  function findOptionWrapperByValue(variantSelects, value) {
    if (!variantSelects || value == null || value === '') return null;
    const wrappers = variantSelects.querySelectorAll('.product-form__input');
    for (let i = 0; i < wrappers.length; i++) {
      const select = wrappers[i].querySelector('select');
      if (select) {
        const has = Array.from(select.options || []).some((opt) => String(opt.value) === String(value));
        if (has) return wrappers[i];
      } else {
        const radio = wrappers[i].querySelector('input[type="radio"][value="' + String(value).replace(/"/g, '\\"') + '"]');
        if (radio) return wrappers[i];
      }
    }
    return null;
  }

  /**
   * Mirror loading state from hidden submit to visible CTA; clear when submit loses .loading.
   */
  function mirrorTriggerLoadingFromSubmit(submit, triggerBtn) {
    if (!submit || !triggerBtn) return;
    if (!submit.classList.contains('loading')) return;

    triggerBtn.classList.add('loading');
    triggerBtn.setAttribute('disabled', '');
    triggerBtn.setAttribute('aria-busy', 'true');
    var spinner = triggerBtn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    function clearTrigger() {
      triggerBtn.classList.remove('loading');
      triggerBtn.removeAttribute('disabled');
      triggerBtn.removeAttribute('aria-busy');
      var sp = triggerBtn.querySelector('.loading__spinner');
      if (sp) sp.classList.add('hidden');
      observer.disconnect();
    }

    var observer = new MutationObserver(function () {
      if (!submit.classList.contains('loading')) {
        clearTrigger();
      }
    });
    observer.observe(submit, { attributes: true, attributeFilter: ['class'] });
  }

  /**
   * Sync variant picker for subscribe vs one-time, then submit hidden form.
   * @param {Element} container - card-wrapper (form lives in hidden .card-content-2)
   * @param {Element|null} triggerBtn - visible .subscribe-btn or .one-time-btn
   */
  function syncVariantAndQuickAdd(container, isSubscribe, triggerBtn, options) {
    const opts = options || {};
    const preserveSelectedOptions = !!opts.preserveSelectedOptions;
    const form = container.querySelector('product-form form');
    if (!form) return;
    const variantSelects = form.querySelector('variant-selects');
    const sellingPlanInput = getOrCreateSellingPlanInput(form);

    if (variantSelects) {
      if (isSubscribe) {
        // Keep user's other selections (e.g. color/size) when requested; only switch subscription option.
        let subscriptionWrapper = findOptionWrapperByLabel(variantSelects, ROAST_TYPE_LABEL);
        if (!subscriptionWrapper) {
          subscriptionWrapper = findOptionWrapperByValue(variantSelects, SUBSCRIPTION_VALUE);
        }
        if (subscriptionWrapper) setOptionAndDispatchChange(subscriptionWrapper, SUBSCRIPTION_VALUE);
        const planId = form.getAttribute('data-plan-id-2w');
        sellingPlanInput.value = planId != null ? planId : '';
      } else {
        // One-time: either preserve current selection (Merch inline) or reset to default option values (list cards).
        if (!preserveSelectedOptions) {
          const values = [
            form.getAttribute('data-option-1-value') || form.dataset.option1Value,
            form.getAttribute('data-option-2-value') || form.dataset.option2Value,
            form.getAttribute('data-option-3-value') || form.dataset.option3Value
          ];
          const wrappers = variantSelects.querySelectorAll('.product-form__input');
          for (let i = 0; i < wrappers.length; i++) {
            const value = values[i];
            if (value != null && value !== '') {
              setOptionAndDispatchChange(wrappers[i], value);
            }
          }
        }
        sellingPlanInput.value = '';
      }
    } else {
      // Pickers omit <variant-selects> for has_only_default_variant — still set selling plan and submit.
      if (isSubscribe) {
        const planId = form.getAttribute('data-plan-id-2w');
        sellingPlanInput.value = planId != null ? planId : '';
      } else {
        sellingPlanInput.value = '';
      }
    }

    const priceContainer = container.querySelector('.price-container_modal');
    if (priceContainer) {
      const oneTimeBlock = priceContainer.querySelector('.price-block--one-time');
      const subscriptionBlock = priceContainer.querySelector('.price-block--subscription');
      if (isSubscribe && subscriptionBlock) {
        if (oneTimeBlock) oneTimeBlock.style.display = 'none';
        subscriptionBlock.style.display = '';
      } else {
        if (oneTimeBlock) oneTimeBlock.style.display = '';
        if (subscriptionBlock) subscriptionBlock.style.display = 'none';
      }
    }

    const submitBtn = container.querySelector('.quick-add__submit') || container.querySelector('form [type="submit"]');
    if (submitBtn) {
      const textSpan = submitBtn.querySelector('span:first-child');
      const addToCartText = form.getAttribute('data-add-to-cart-text');
      const addToBoxText = form.getAttribute('data-add-to-box-text');
      if (textSpan && (addToCartText != null || addToBoxText != null)) {
        textSpan.textContent = isSubscribe && addToBoxText ? addToBoxText : (addToCartText || 'Add to cart');
      }
    }

    function doSubmit() {
      const submit = container.querySelector('product-form form [type="submit"]');
      if (submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submit);
        } else {
          submit.click();
        }
        if (triggerBtn) {
          mirrorTriggerLoadingFromSubmit(submit, triggerBtn);
        }
      }
    }

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(doSubmit);
    } else {
      doSubmit();
    }
  }

  function openMerchInlinePicker(cardWrapper, intent) {
    if (!cardWrapper) return;
    cardWrapper.classList.add('is-inline-picker-open');
    if (intent) {
      cardWrapper.setAttribute('data-open-intent', intent);
    }
  }

  function closeMerchInlinePicker(cardWrapper) {
    if (!cardWrapper) return;
    cardWrapper.classList.remove('is-inline-picker-open');
    cardWrapper.removeAttribute('data-open-intent');
  }

  function handleClick(e) {
    const inModal = e.target.closest('modal-dialog[id^="' + MODAL_PREFIX + '"]');
    const inCard = e.target.closest(CARD_WRAPPER_SELECTOR);
    if (!inCard && !inModal) return;

    // Navigate to PDP when clicking non-interactive areas (hover overlays block the full-card <a>)
    if (inCard && !inModal) {
      const rawPdpWrap = e.target.closest(CARD_WRAPPER_SELECTOR + '[data-pdp-url]');
      const pdpWrap =
        rawPdpWrap &&
        (rawPdpWrap.closest(LIST_SELECTOR) || rawPdpWrap.closest(BOX_GRID_SELECTOR))
          ? rawPdpWrap
          : null;
      if (pdpWrap) {
        if (!e.target.closest('product-form')) {
          const interactive = e.target.closest('a, button, input, select, textarea, label');
          if (!interactive) {
            const url = pdpWrap.getAttribute('data-pdp-url');
            if (url) {
              e.preventDefault();
              window.location.assign(url);
              return;
            }
          }
        }
      }
    }

    const backBtn = e.target.closest('.card-product-list__back');
    if (backBtn) {
      const cardWrapper = resolveCardWrapper(e.target);
      if (cardWrapper && cardWrapper.dataset && cardWrapper.dataset.productType === 'merch') {
        e.preventDefault();
        closeMerchInlinePicker(cardWrapper);
      }
      return;
    }

    const merchInlineSubscribe = e.target.closest('.merch-inline-subscribe');
    const merchInlineOnetime = e.target.closest('.merch-inline-onetime');
    if (merchInlineSubscribe || merchInlineOnetime) {
      const cardWrapper = resolveCardWrapper(e.target);
      if (!cardWrapper) return;
      e.preventDefault();
      const isSubscribe = !!merchInlineSubscribe;
      syncVariantAndQuickAdd(cardWrapper, isSubscribe, merchInlineSubscribe || merchInlineOnetime, {
        preserveSelectedOptions: true
      });
      return;
    }

    const bisOpenBtn = e.target.closest('.bis-open-btn');
    if (bisOpenBtn) {
      e.preventDefault();
      const handle = bisOpenBtn.getAttribute('data-product-handle');
      if (handle && typeof window.xbloomOpenBISModalForHandle === 'function') {
        window.xbloomOpenBISModalForHandle(handle);
      }
      return;
    }

    const mobileOpen = e.target.closest(MOBILE_ADD_TRIGGER);
    if (mobileOpen && isMobile()) {
      e.preventDefault();
      const sid = mobileOpen.getAttribute('data-section-id');
      const pid = mobileOpen.getAttribute('data-product-id');
      var modalId = sid && pid ? MODAL_PREFIX + sid + '-' + pid : null;
      var modal = modalId ? document.getElementById(modalId) : null;
      if (modal && typeof modal.show === 'function') {
        modal.show(mobileOpen);
      }
      return;
    }

    const triggerBtn = e.target.closest(TRIGGER_SELECTORS);
    if (triggerBtn) {
      e.preventDefault();
      const subscribeBtn = e.target.closest('.subscribe-btn');
      const isSubscribe = !!subscribeBtn;

      // If clicking inside a CardQuickAdd modal that contains a product-form,
      // submit the modal's own form (preserve user's selected options).
      if (inModal && inModal.querySelector('product-form form')) {
        syncVariantAndQuickAdd(inModal, isSubscribe, triggerBtn, { preserveSelectedOptions: true });
        return;
      }

      const cardWrapper = resolveCardWrapper(e.target);
      if (!cardWrapper) return;

      // Desktop Merch: single-variant submits immediately; multi-variant opens inline picker.
      if (!isMobile() && cardWrapper.dataset && cardWrapper.dataset.productType === 'merch') {
        if (cardWrapper.dataset.singleVariant === 'true') {
          syncVariantAndQuickAdd(cardWrapper, isSubscribe, triggerBtn);
        } else {
          openMerchInlinePicker(cardWrapper, isSubscribe ? 'subscribe' : 'buy');
        }
        return;
      }

      syncVariantAndQuickAdd(cardWrapper, isSubscribe, triggerBtn);
      return;
    }
  }

  document.addEventListener('click', handleClick);

  /** Close mobile quick-add bottom sheet after successful add (product-form publishes cartUpdate). */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;
      var openModal = document.querySelector(
        'modal-dialog[id^="' + MODAL_PREFIX + '"][open]'
      );
      if (openModal && typeof openModal.hide === 'function') {
        openModal.hide();
      }
    });
  }
})();
